import {
    Component,
    OnInit,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent as ListComponent_1 , ListComponent } from "@components/list/list.component";
import { PageComponent } from "@components/page/page.component";
import { BusyService } from "~app/common/components/busy/busy.service";

import { CommandService } from "~app/common/services/cqs/command.service";
import { JobbDetailsDTO } from "../jobb.models";
import { JobbService } from "../jobb.service";
import { ModifyJobbStatusCommand } from "./ModifyJobbStatusCommand";

@Component({
    selector: "rask-jobb-details",
    templateUrl: "./jobb-details.component.html",
    styleUrls: ["./jobb-details.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        BlockComponent,
        InputNumberComponent,
        FormsModule,
        ListComponent_1,
        ListColumnDirective,
        ButtonComponent
    ]
})
export class JobbDetailsComponent implements OnInit {
    antalForsok?: number;
    jobbDetailList: JobbDetailsDTO[];
    @ViewChild("jobbdetails") searchResultTable: ListComponent;
    selectedRows: any[];
    status: any;
    typ: string;

    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly busyService = inject(BusyService);
    private readonly commandService = inject(CommandService);
    private readonly service = inject(JobbService);

    canChangeStatus() {
        return this.selectedRows && this.selectedRows.length > 0;
    }

    ngOnInit(): void {
        const { typ, status } = this.activatedRoute.snapshot.params;
        this.typ = typ;
        this.status = status;
        this.service.refreshJobb();
        this.service.currentjobb$.subscribe(x => {
            const jobb = x.find(y => y.typ === this.typ);
            const list = jobb?.details?.filter(y => y.status === this.status);
            this.jobbDetailList = list ? list : [];
        });
    }

    onCheckedChange() {
        this.selectedRows =  this.searchResultTable.getSelectedRows();
    }

    uppdateraStatus(status: string) {
        this.selectedRows.forEach(x => {
            const cmd = new ModifyJobbStatusCommand(c => {
                c.id = x.id;
                c.jobbStatus = status;
                c.antalForsok = this.antalForsok;
            });
            this.commandService.addTransactionCommand(cmd);
        });
        const worker = this.busyService.addWork(this.commandService.pushCommandQueueTransaction());
        worker.subscribe(result => {
            this.service.refreshJobb();
        });
    }
}
